import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate } from 'react-router-dom';

import ChatPage from './ChatPage';
import HomePage from './HomePage';
import ChatSelection from './ChatSelection';
import EtudePage from './EtudePage';
import AfterCoachPage from './AfterCoachPage';
import QuestionnairePage from './QuestionnairePage';
import { LanguageProvider } from './i18n';



function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          {/* <Route path="/" element={<HomePage />} /> */}
          <Route path="/" element={<Navigate to="/etude" replace />} />
          <Route path="/etude" element={<EtudePage />} />
          <Route path="/after-coach" element={<AfterCoachPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/chat-selection" element={<ChatSelection />} />
          <Route path="/questionnaire" element={<QuestionnairePage />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
